import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { AppConfigService } from 'app/services/app-config/app-config.service';
import { UserFeatureService } from '../../services/user-feature/user-feature.service';
import { UserService } from 'app/services/user/user.service';
import { FeatureType } from 'app/model/constant';
import { AuthenticationService } from 'app/services/authentication/authentication.service';
import { redirectURIV2 } from 'environments/properties';

@Component({
  selector: 'app-account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss']
})
export class AccountMenuComponent implements OnInit, OnDestroy {
  @Input('page') currentPage: string;

  public user: any;
  private userSubRef: any;

  public canChangePassword = true;
  public showApprovalList = false;
  public showPermission = true;
  public showFleetMenu = true;
  public isB2C: boolean = false;
  public showPreApprovalRequester = false;
  public showPreApprovalApprover = false;

  public redirectURIV2 = redirectURIV2;

  constructor(
    private userService: UserService,
    private userFeatureService: UserFeatureService,
    private appConfigService: AppConfigService,
    private authenticationService: AuthenticationService
  ) {
    this.isB2C = this.authenticationService.isB2CClient();
  }

  ngOnInit() {
    this.user = this.userService.getUser();
    this.canChangePassword = this.userFeatureService.canChangePassword();
    this.showApprovalList = this.userFeatureService.canShowApprovalList();
    this.showPreApprovalRequester = this.userFeatureService.enablePreApprovalRequester();
    this.showPreApprovalApprover = this.userFeatureService.enablePreApprovalApprover();
    this.showPermission =
      this.userService.getUserFeature(FeatureType.ALLOW_DISPLAY_PERMISSION_MENU, true) &&
        this.userService.getUserFeature(FeatureType.ALLOW_DISPLAY_PERMISSION_MENU, true).allow != undefined ?
        this.userService.getUserFeature(FeatureType.ALLOW_DISPLAY_PERMISSION_MENU, true).allow : this.showPermission;

    this.userSubRef = this.userService.getUserObs().subscribe(user => {
      this.user = user;
    });
  }

  getLang() {
    return this.appConfigService.getLanguage();
  }

  getUserPicture() {
    let _userImg = this.user.PicturePath;
    if (_userImg == '/assets/img/avatar/nopicture.gif') {
      // Not have User Image
      return "/assets/images/header/user_default_display.png"
    } else {
      // Have User Image
      return _userImg
    }
  }

  ngOnDestroy() {
    this.userSubRef ? this.userSubRef.unsubscribe() : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/account-menu/account-menu.component.ts